import { render, staticRenderFns } from "./DetailRole.vue?vue&type=template&id=39ce9114"
import script from "./DetailRole.vue?vue&type=script&lang=js"
export * from "./DetailRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports